/* eslint-disable no-console */
import { useState } from "react";
import {
  Form,
  Input,
  FormField,
  Button,
  Divider,
} from "semantic-ui-react";
import Swal from "sweetalert2";
import { useAuth } from "../../../../../hooks";
import { User } from "../../../../../api";
import "./PasswordUpdateForm.scss";

const userController = new User();

export function PasswordUpdateForm() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { accessToken } = useAuth();

  const handleShowCurrentPassword = () =>
    setShowCurrentPassword((prev) => !prev);
  const handleShowNewPassword = () => setShowNewPassword((prev) => !prev);
  const handleShowConfirmPassword = () =>
    setShowConfirmPassword((prev) => !prev);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!currentPassword || !newPassword || !confirmPassword) {
      Swal.fire({
        icon: "warning",
        title: "Campos requeridos",
        text: "Por favor, completa todos los campos de contraseña.",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#f39c12",
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Error de validación",
        text: "Las contraseñas nuevas no coinciden.",
        confirmButtonText: "Intentar de nuevo",
        confirmButtonColor: "#db2828",
      });
      return;
    }

    if (newPassword.length < 8) {
      Swal.fire({
        icon: "warning",
        title: "Contraseña muy corta",
        text: "La nueva contraseña debe tener al menos 8 caracteres.",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#f39c12",
      });
      return;
    }

    if (currentPassword === newPassword) {
      Swal.fire({
        icon: "warning",
        title: "Contraseña igual",
        text: "La nueva contraseña debe ser diferente a la actual.",
        confirmButtonText: "Entendido",
        confirmButtonColor: "#f39c12",
      });
      return;
    }

    setLoading(true);

    try {
      await userController.changePassword(currentPassword, newPassword);

      Swal.fire({
        icon: "success",
        title: "¡Perfecto!",
        text: "Contraseña actualizada exitosamente.",
        confirmButtonText: "Continuar",
        confirmButtonColor: "#2185d0",
      });

      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error al actualizar contraseña",
        text: error.msg ||
              error.message ||
              "Error al actualizar la contraseña. Inténtalo de nuevo.",
        confirmButtonText: "Intentar de nuevo",
        confirmButtonColor: "#db2828",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="password-update-form-container">
      <Divider className="divider-menu" />
      <Form
        className="password-sidebar-form"
        onSubmit={handleSubmit}
      >
        <FormField>
          <Input
            icon="lock"
            iconPosition="left"
            placeholder="Contraseña actual"
            type={showCurrentPassword ? "text" : "password"}
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            action={{
              icon: showCurrentPassword ? "eye slash" : "eye",
              onClick: handleShowCurrentPassword,
              type: "button",
              title: showCurrentPassword ? "Ocultar" : "Mostrar",
            }}
          />
        </FormField>
        <FormField>
          <Input
            icon="lock"
            iconPosition="left"
            placeholder="Nueva contraseña"
            type={showNewPassword ? "text" : "password"}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            action={{
              icon: showNewPassword ? "eye slash" : "eye",
              onClick: handleShowNewPassword,
              type: "button",
              title: showNewPassword ? "Ocultar" : "Mostrar",
            }}
          />
        </FormField>
        <FormField>
          <Input
            icon="lock"
            iconPosition="left"
            placeholder="Confirma nueva contraseña"
            type={showConfirmPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            action={{
              icon: showConfirmPassword ? "eye slash" : "eye",
              onClick: handleShowConfirmPassword,
              type: "button",
              title: showConfirmPassword ? "Ocultar" : "Mostrar",
            }}
          />
        </FormField>
        <Button fluid type="submit" disabled={loading} loading={loading}>
          Actualizar contraseña
        </Button>
      </Form>
    </div>
  );
}
